import React, { useRef, useEffect } from "react";
import FadeImage from "../images/landing-page-bg/white-fade.png";
import classnames from "classnames";

const BackgroundVideo = (data) => {
  const { video, image, imageclasses, fullscreen } = data;
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.addEventListener("ended", handleVideoEnded);
    }

    return () => {
      const currentVideoRef = videoRef.current;
      if (currentVideoRef) {
        currentVideoRef.removeEventListener("ended", handleVideoEnded);
      }
    };
  }, []);

  const handleVideoEnded = () => {
    if (videoRef.current) {
      const currentVideoRef = videoRef.current;
      // Check if the video has reached the end 3 times
      if (currentVideoRef.currentTime >= currentVideoRef.duration * 3) {
        // Reset the video to the beginning
        currentVideoRef.currentTime = 0;
        currentVideoRef.play();
      }
    }
  };

  return (
      <>
        {video ? (
            <>
              <div
                  className={classnames(
                      "w-screen h-full absolute top-0 left-0",
                      image ? "flex" : ""
                  )}
              >
                <video
                    ref={videoRef}
                    autoPlay
                    muted
                    className="fixed w-screen object-fill h-screen top-0 left-0"
                >
                  <source src={video} type="video/mp4" />
                </video>
              </div>
              <div className="fixed top-0 left-0 w-screen">
                <img src={FadeImage} className="w-screen" alt="fade" />
              </div>
            </>
        ) : null}

        {image ? (
            <div
                className={classnames(
                    "w-screen ",
                    !fullscreen
                        ? "relative h-[calc(100vh-312px)]"
                        : "h-[calc(100vh-172px)]"
                )}
            >
              <img
                  src={image}
                  alt="Background image"
                  className={classnames("w-full", imageclasses)}
              />
            </div>
        ) : null}
      </>
  );
};

export default BackgroundVideo;